module.exports = __webpack_public_path__ + "static/img/klab-logo.36166d7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/klab-logo.svg
// module id = kfES
// module chunks = 0